import evalCondition from 'Helpers/evalCondition'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import { Button, PageHeader } from 'mailup-web-components'

import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useRecoilValue } from 'recoil'
import { pageState } from '../recoil/state/page'

const Header = () => {
  const intl = useIntl()
  const history = useHistory()
  const [redirectUrl] = useRedirectorUrl()

  const { isEmptyState } = useRecoilValue(pageState)

  useEffect(() => {
    notifyParent('selectMenuItemReact', ['ContentsCampaignList', redirectUrl])
  }, [redirectUrl])

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Automation' }),
      'data-mu-test': 'breadcrumb-item__automation',
      className: 'test-breadcrumb-item__automation'
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Content' }),
      'data-mu-test': 'breadcrumb-item__content',
      className: 'test-breadcrumb-item__content',
      url: '#',
      onClick: () => history.push('/automation/sources/list')
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.ContentsCampaignList' }),
      'data-mu-test': 'breadcrumb-item__ContentsCampaignList',
      className: 'test-breadcrumb-item__ContentsCampaignList'
    }
  ]

  const menuItems = [
    ...(evalCondition(
      'uo:NL AND uo:ENHTRIGGEREDUSE AND co:ENHTRIGGEREDUSE AND uo:CONTENTSSOURCES'
    )
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.ContentsSources' }),
            'data-mu-test': 'topmenu-item__contentsSources',
            className: 'test-topmenu-item__contentsSources',
            onClick: () => history.push('/automation/sources/list')
          }
        ]
      : []),

    {
      label: intl.formatMessage({
        id: 'Load.NavMenu.ContentsCampaignList'
      }),
      isActive: true,
      className: 'test-topmenu-item__contentsCampaignList'
    },

    ...(evalCondition('uo:DYNFLD')
      ? [
          {
            label: intl.formatMessage({ id: 'Load.NavMenu.DynamicContent' }),
            onClick: () => history.push('/automation/dynamiccontent/list'),

            'data-mu-test': 'topmenu-item__emailSmtpPlusList',
            className: 'test-topmenu-item__emailSmtpPlusList'
          }
        ]
      : [])
  ]

  const onClickNewCampaign = () => {
    history.push('/automation/contentsCampaign/0/0')
  }

  const ControlsComponent = () =>
    isEmptyState ? null : (
      <Button
        kind='primary'
        size='lg'
        onClick={onClickNewCampaign}
        data-mu-test='header-button'
      >
        {intl.formatMessage({ id: 'Load.ContentsCampaignList.New' })}
      </Button>
    )

  return (
    <PageHeader
      breadcrumbsItems={breadcrumbsItems}
      menuItems={menuItems}
      ControlsComponent={ControlsComponent}
      title={intl.formatMessage({ id: 'Load.NavMenu.ContentsCampaignList' })}
    />
  )
}

export default Header
